<template>
  <!-- 単一ルート必須: 横スクロール列の 1 コマとして扱うため、幅と shrink-0 は親が外から class で与える。
       複数ルートだと class の fallthrough が効かず、スナップ位置もずれる。 -->
  <div class="overflow-clip" data-testid="journey-video-card">
    <!--
      title を渡す理由は表示ではない（タイトルはサムネイル画像に焼き込まれている）。
        1. facade の useYouTubeTitle は title が falsy のときだけ発火する。渡すことで oEmbed への
           リクエストが 1 本も出なくなる
        2. 再生ボタンの aria-label（`Play video: <title>`）になる
      show-overlay-title=false はデザインに hover タイトルが無いため。
    -->
    <YouTubeFacade :on-playing="handlePlaying" :show-overlay-title="false" :title="props.video.title" :video-id="props.video.videoId" />
  </div>
</template>

<script lang="ts" setup>
import YouTubeFacade from '@/wabunka-src/common/features/Featured/components/YouTubeFacade/YouTubeFacade.vue';
import type { JourneyVideo } from '@/wabunka-src/constants/journeyThroughJapanVideos';

const props = defineProps<{
  video: JourneyVideo;
  onPlaying?: (video: JourneyVideo) => void;
}>();

const handlePlaying = () => props.onPlaying?.(props.video);
</script>
